<template>
	<div class="accountSetting pl-xl-4">
        <div class="border-bottom pb-3 mb-4">
    		<h3 class="medium "> Organization Info</h3>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                    <label class="medium mb-2">Organization Legal Name</label>
                    <input type="text" class="form-control" :placeholder="profileInfo.legal_name || '-'" name="" disabled>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                    <label class="medium mb-2">Organization Type</label>
                    <input type="text" class="form-control" :placeholder="(profileInfo.org_type && OrganizationType[profileInfo.org_type])?OrganizationType[profileInfo.org_type]:'-'" name="" disabled>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                    <label class="medium mb-2">Business Activites & Source of Funds</label>
                    <input type="text" class="form-control" :placeholder="profileInfo.src_of_funds || '-'" name="" disabled>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                    <label class="medium mb-2">Organization’s Tax ID</label>
                    <input type="text" class="form-control" :placeholder="profileInfo.tax_id || '-'" name="" disabled>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                    <label class="medium mb-2">Business’s Registered Office Address</label>
                    <input type="text" class="form-control" :placeholder="profileInfo.org_address || '-'" name="" disabled>
                </div>
            </div>
            <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                    <label class="medium mb-2">Organization Registered Country</label>
                    <input type="text" class="form-control" :placeholder="profileInfo.registered_country?($env_var.countriesList[profileInfo.registered_country]? $env_var.countriesList[profileInfo.registered_country].name:profileInfo.registered_country): '-'" name="" disabled>
                </div>
            </div>
        </div>
        <!-- <div class="buttons d-flex align-items-center justify-content-end border-top pt-4 mt-4">
            <a href="javascript:void(0)" class="cap_btn-b mr-3 min-auto">Cancel</a>
            <a href="javascript:void(0)" class="cap_btn">Save</a>
        </div> -->
		
    </div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
// import editAddress from './edit_Address'
// import editNumber from './edit_Number'
export default {
    name: 'accountprofile',
    mixins: [registerStepsMixins],
    data() {
        return {
            notification_msg:'',
            notification_type:'',
            // tab: '1',
            submitted: false,
            // editAddress: false,
            // editNumber: false,

            fname: '',
            mName: '',
            lname: '',
            dob: '',
            address: '',
            city: '',
            state: '',
            country: '',
            area_code: '',
            acc_type: '',
            OrganizationType:{
            	'1':'Company',
            	'2':'Self Managed Super Fund',
            	'3':'Discretionary/Unit Trust',
            	'4':'Others'
            }
        }
    },
    components:{
        // editAddress,
        // editNumber 
    },

    methods: {
        create_image(url,name){
            var stx = this.stxx
            var link = document.createElement('a');
            link.download = name;
            link.href = url
            link.click();
        },
        ChangeTab(val){
            this.tab = val
            // this.editAddress = false
            // this.editNumber = false
            this.pageLoader = false
        },
        Submit() {
            const _that = this
            _that.submitted = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json = {
                        'globalParams': {
                            'f_name': _that.fname,
                            'm_name': _that.mName,
                            'l_name': _that.lname,
                            'dob': _that.dob,
                            'Address': _that.address,
                            'City': _that.city,
                            'State': _that.state,
                            'Country': _that.country,
                            'Areacode': _that.area_code,
                            'Acc_type': _that.acc_type,
                        },
                        localParams: {
                            "parameter": _that
                        }
                    }

                }
            });
        }
    },
    created() {
        /*this.pageName('Account Profile')
        this._runGetProfileInfo({
            globalParams: {
				
			},
            localParams: {
                "parameter": this
            }
        })*/
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/organization_info.vue